module.exports = __webpack_public_path__ + "static/media/hdi-provider.4391d2ed.svg";